import React, {useEffect, useState} from 'react';
import logo from './assets/litiges.png'
import Swal from 'sweetalert2'

function App() {
  const [files, setFiles] = useState([]);
  const [selectedDossier, setSelectedDossier] = useState(null);
  const [fichiers, setFichiers] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState({ dossiers: false, details: false, allFiles: false });
  const [dateDebut, setDateDebut] = useState(null);
  const [dateFin, setDateFin] = useState(null);
  const [openDossier, setOpenDossier] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [refDossier, setRefDossier] = useState(null);
  const [file, setFile] = useState(null);

  //
  useEffect(() => {
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);

    const defaultDateDebut = `${threeMonthsAgo.getFullYear()}-${String(threeMonthsAgo.getMonth() + 1).padStart(2, '0')}-${String(threeMonthsAgo.getDate()).padStart(2, '0')}`;
    const defaultDateFin = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    // Set initial state with default dates
    setDateDebut(defaultDateDebut);
    setDateFin(defaultDateFin);
  }, []);

  //Fonction cherchant les dopssiers entre une date X et Y
  const fetchFiles = async (dateDebut, dateFin) => {
    try {

      setLoading((prev) => ({ ...prev, dossiers: true }));
      const response = await fetch(`https://litiges.assistance-expertise-batiment.com/api/getFiles?dateDebut=${dateDebut}&dateFin=${dateFin}`);

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des dossiers');
      }

      const data = await response.json();
      console.log("Dossiers récupérés:", data);
      setFiles(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, dossiers: false }));
    }
  };

  //récupère les dates passées par le formulaire et les passer à la requête en back.
  const handleDateChange = async (e) => {
    e.preventDefault();
    try {
      await fetchFiles(dateDebut, dateFin);

    } catch (error) {
      console.error("Erreur lors de la récupération des fichiers:", error);
    }
  };

  // Fonction pour récupérer les détails d'un dossier spécifique
  const fetchDossierDetails = async (refDossier) => {
    try {
      setLoading((prev) => ({ ...prev, details: true }));
      const response = await fetch(`https://litiges.assistance-expertise-batiment.com/api/getDossier/${refDossier}`);
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des détails du dossier');
      }
      const details = await response.json();
      console.log("Détails du dossier récupéré:", details);

      setSelectedDossier(details);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, details: false }));
    }
  };


  //fonction de recherche dossier par ID
  const getFileById = async (event) => {

    event.preventDefault()
    const response = await fetch(`https://litiges.assistance-expertise-batiment.com/api/getDossier/${refDossier}`);
    if (!response.ok) {
      await Swal.fire({
        title: 'Succès',
        text: response.text(),
        icon: "success",
        heightAuto: true
      });
    }
    const file = await response.json()
    setFiles(file)
    setRefDossier(file.Id)
    return file
  }

  //fonction affchant les fichiers d'un dossier
  const fetchDossierFiles = async (refDossier) => {
    try {
      setLoading((prev) => ({ ...prev, allFiles: true }));
      const response = await fetch(`https://litiges.assistance-expertise-batiment.com/api/getFichiers/${refDossier}`);
      if (!response.ok) {
        await Swal.fire({
          title: 'Erreur',
          text: response.text(),
          icon: "error",
          heightAuto: true
        });
      }
      const files = await response.json();
      console.log("Fichiers du dossier récupérés:", files);

      // Vérifier si les fichiers ont déjà été envoyés
      const promises = files.map(async (file) => {
        const response = await fetch(`https://litiges.assistance-expertise-batiment.com/api/checkSentFile/${refDossier}/${file.Id}`);
        const fileInfo = await response.json();
        return { ...file, sent: fileInfo.sent, dateSent: fileInfo.dateSent };
      });

      const filesWithSentInfo = await Promise.all(promises);


      // Mettre à jour les fichiers dans l'état
      setFichiers(filesWithSentInfo);
    } catch (error) {
      setError(error.message);
      await Swal.fire({
        title: 'Erreur',
        text: error,
        icon: "error",
        heightAuto: true
      });
    } finally {
      setLoading((prev) => ({ ...prev, allFiles: false }));
    }
  };


  //envoie les coordonnées d'un expert
  const sendExpertInfo = async (refDossier) => {
  console.log(refDossier);
    try {
      const response = await fetch(`https://litiges.assistance-expertise-batiment.com/api/expertInfo/${refDossier}`);

      if (!response.ok) {
         const errorDetails = await response.text();
         console.log(errorDetails);
        throw new Error(errorDetails);

      }
      const expertData = await response.json();

      const expertCode = expertData.IdActeurExpert;

      await Swal.fire({
        title: 'Succès',
        text: expertData.message,
        icon: "success",
        heightAuto: true
      });
      return expertCode;
    } catch (error) {
      await Swal.fire({
        title: 'Erreur',
        text: error,
        icon: "error",
        heightAuto: true
      });
    }
  };

  async function sendFiles(refDossier) {
    try {
      // Récupérer les IDs des fichiers sélectionnés
      const selectedFileIds = Object.keys(selectedFiles).filter(id => selectedFiles[id]);

      if (selectedFileIds.length === 0) {
        // alert("Veuillez sélectionner au moins un fichier à envoyer.");
        await Swal.fire({
          title: "Attention !",
          text: "Veuillez sélectionner au moins un fichier à envoyer",
          icon: "question",
          heightAuto: true
        });
        return;
      }

      const response = await fetch(`https://litiges.assistance-expertise-batiment.com/api/sendDossier/${refDossier}`, {
        method: 'POST', // Changé de GET à POST
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ selectedFileIds }) // Envoi des IDs des fichiers sélectionnés
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erreur lors de l'envoi des informations du dossier: ${errorText}`);
      }

      const result = await response.json();
      // alert(result.message); // Message pour indiquer le succès de l'opération
      await Swal.fire({
        title: "OK",
        text: result.message,
        icon: "success",
        heightAuto: true
      });
      // Réinitialiser la sélection après un envoi réussi
      setSelectedFiles({});

      // Optionnel : Rafraîchir la liste des fichiers pour refléter les changements
      // await fetchDossierFiles(refDossier);

    } catch (error) {
      console.error('Erreur:', error);
      alert(`Une erreur est survenue lors de l'envoi des informations: ${error.message}`);
    }
  }

  const handleFileSelection = (fileId) => {
    setSelectedFiles(prev => ({
      ...prev,
      [fileId]: !prev[fileId]
    }));
  };

  const sortedFichiers = files.filter((dossier) => dossier.EtatDossier === 0).sort((a, b) => {
    if (a.Libelle < b.Libelle) return -1; // a vient avant b
    if (a.Libelle > b.Libelle) return 1;  // a vient après b
    return 0; // a et b sont égaux
  });




  return (
      <div className="bg-gradient-to-tr from-blue-50  to-gray-100 min-h-screen p-4">
        <img src={logo} className="w-60 h-auto" alt="logo litiges"/>
        <div className="w-full bg-gray-400 p-4 my-4 flex justify-between">
          <div className="">
            <h3 className="text-center text-2xl pb-1">Recherche par date </h3>
            <h4 className="text-center font-black text-red-700 pb-3">(par tranche de trimestres uniquement)</h4>
            <form onSubmit={handleDateChange} className="h-full">
              <div className="flex gap-2">
                <div className="flex gap-2">
                  <label htmlFor="dateDebut" className="font-bold">Du</label>
                  <input
                      id="dateDebut"
                      type="date"
                      value={dateDebut}
                      // defaultValue={defaultDateDebut}
                      onChange={(e) => setDateDebut(e.target.value)}
                      required
                      className="rounded-xl pl-2"
                  />
                </div>
                <div className="flex gap-2">
                  <label htmlFor="dateFin" className="font-bold">Au</label>
                  <input
                      id="dateFin"
                      type="date"
                      value={dateFin}
                      // defaultValue={defaultDateFin}
                      onChange={(e) => setDateFin(e.target.value)}
                      required
                      className="rounded-xl pl-2"
                  />
                </div>
                <button type="submit" className="py-1 px-4 bg-blue-100 rounded-2xl">Rechercher</button>
              </div>
            </form>
          </div>
          <div>
            <h3 className="text-center text-2xl pb-3">Recherche par numéro de dossier</h3>
            <form onSubmit={getFileById}>
              <div className="flex gap-2">
                <input
                    className="rounded-xl py-1 px-4"
                    placeholder="Num de dossier"
                    onChange={(e) => setRefDossier(e.target.value)}
                    id="numFile"
                    type="text"/>
                <button type="submit" className="py-1 px-4 bg-blue-100 rounded-2xl">Rechercher</button>
              </div>

            </form>
          </div>

        </div>
        <h2 className="text-4xl mb-4 text-center">Liste des dossiers</h2>

        {error && <p className="text-red-500 mb-4">{error}</p>}

        {loading.dossiers ? (
            <p>Chargement des dossiers...</p>
        ) : (
            <ul className="grid grid-cols-4 gap-5">
              {sortedFichiers.map((dossier, index) => (
                  <li key={index}
                      className={`relative bg-white border-[1px] rounded-xl rounded-b-none border-blue-200 hover:shadow-xl hover:bg-blue-50 transition-all duration-300`}>
                    <div
                        className="bg-[#a8c8f0] p-4 rounded-lg rounded-b-none flex flex-col justify-center items-center ">

                      <h3 className="text-lg font-bold mb-2">{dossier.RefDossier}</h3>
                      <h2 className="mb-2">{dossier.Libelle}</h2>
                    </div>
                    <div>
                      <div className={`flex justify-center gap-2 m-3  `}>
                        <button
                            className="bg-blue-300 py-1 px-4 rounded-3xl"
                            onClick={() => sendExpertInfo(dossier.RefDossier)}
                        >Envoyer les informations
                        </button>
                        <button
                            className={`bg-gray-300 py-1 px-4 rounded-3xl`}
                            onClick={() => {
                              fetchDossierFiles(dossier.RefDossier);
                              setOpenDossier(openDossier === dossier.RefDossier ? null : dossier.RefDossier);
                            }}
                        >
                          {openDossier === dossier.RefDossier ? 'Masquer Fichiers' : 'Voir Fichiers'}
                        </button>

                      </div>
                    </div>

                    {openDossier === dossier.RefDossier && (
                        <div className={`absolute w-full top-full left-0 right-0 z-10 rounded-bl-2xl rounded-br-2xl border-l-[1px] border-b-[1px] border-r-[1px] border-blue-200 shadow-lg p-4 transition-opacity duration-300
    ${fichiers.length > 0 ? 'bg-white' : 'bg-gray-400'} ${loading.dossiers ? 'opacity-50' : 'opacity-100'}`}>
                          <div className="rounded-lg m-auto">
                            {loading.allFiles ? (
                                <p className="text-center">Chargement des fichiers...</p>
                            ) : fichiers.length > 0 ? (
                                <ul className="space-y-2">
                                  {fichiers.map((file, fileIndex) => (
                                      <li key={fileIndex} className="flex items-center">
                                        <input
                                            type="checkbox"
                                            id={`file-${file.Id}`}
                                            checked={selectedFiles[file.Id] || false}
                                            onChange={() => handleFileSelection(file.Id)}
                                            className="mr-2"
                                        />
                                        <label htmlFor={`file-${file.Id}`} className="cursor-pointer">
                                          {file.Libelle}
                                          {file.sent && (
                                              <span className="text-red-600 ml-2 font-bold">
                      (Envoyé le {new Date(file.dateSent).toLocaleString()})
                    </span>
                                          )}
                                        </label>
                                      </li>
                                  ))}
                                </ul>
                            ) : (
                                <p className="text-center text-red-600 font-black">Aucun fichier trouvé pour ce dossier.</p>
                            )}
                          </div>
                          <div className="flex flex-row justify-center w-full">
                            <button
                                className={`bg-emerald-200 py-1 px-4 rounded-3xl mt-4 ${fichiers.length > 0 ? '' : 'hidden'}`}
                                onClick={() => sendFiles(dossier.RefDossier)}
                                // disabled={Object.values(selectedFiles).filter(Boolean).length === 0}
                            >
                              Envoyer les documents sélectionnés
                            </button>
                          </div>
                        </div>
                    )}



                    {/*{openDossier === dossier.RefDossier && (*/}
                    {/*    <div className={`absolute w-full top-full left-0 right-0 z-10 rounded-bl-2xl rounded-br-2xl  border-l-[1px] border-b-[1px] border-r-[1px]  border-blue-200  shadow-lg p-4 transition-opacity duration-300*/}
                    {/*    ${ fichiers.length > 0 ? 'bg-white' : 'bg-gray-400' } ${loading.dossiers ? 'opacity-50' : 'opacity-100'}`}>*/}
                    {/*      <div className="rounded-lg m-auto">*/}
                    {/*        {loading.allFiles ? (*/}
                    {/*            <p className="text-center">Chargement des fichiers...</p>*/}
                    {/*        ) : fichiers.length > 0 ? (*/}
                    {/*            <ul className="space-y-2">*/}
                    {/*              {fichiers.map((file, fileIndex) => (*/}
                    {/*                  <li key={fileIndex} className="flex items-center">*/}
                    {/*                    <input*/}
                    {/*                        type="checkbox"*/}
                    {/*                        id={`file-${file.Id}`}*/}
                    {/*                        checked={selectedFiles[file.Id] || false}*/}
                    {/*                        onChange={() => handleFileSelection(file.Id)}*/}
                    {/*                        className="mr-2"*/}
                    {/*                    />*/}
                    {/*                    <label htmlFor={`file-${file.Id}`} className="cursor-pointer">*/}
                    {/*                      {file.Libelle}*/}

                    {/*                    </label>*/}
                    {/*                  </li>*/}
                    {/*              ))}*/}
                    {/*            </ul>*/}
                    {/*        ) : (*/}
                    {/*            <p className="text-center text-red-600 font-black">Aucun fichier trouvé pour ce dossier.</p>*/}
                    {/*        )}*/}
                    {/*      </div>*/}
                    {/*      <div className="flex flex-row justify-center w-full">*/}
                    {/*        <button*/}
                    {/*            className={`bg-emerald-200 py-1 px-4 rounded-3xl mt-4 ${fichiers.length > 0 ? '' : 'hidden'}`}*/}
                    {/*            onClick={() => sendFiles(dossier.RefDossier)}*/}
                    {/*            disabled={Object.values(selectedFiles).filter(Boolean).length === 0}*/}
                    {/*        >*/}
                    {/*          Envoyer les documents sélectionnés*/}
                    {/*        </button>*/}
                    {/*      </div>*/}

                    {/*    </div>*/}
                    {/*)}*/}
                  </li>
              ))}
            </ul>
        )}
      </div>
  );
}

export default App;